import React from "react";
import { Link } from "react-router-dom";
import { htmlToExcerpt } from "../../utils/sanitizeHtml";
import { isHiringAcceptingApplications } from "../../utils/userRole";
import FitCoverImage from "./FitCoverImage";

/**
 * Hiring / job ad teaser for feed and sidebar.
 */
export default function HiringCard({
  post,
  linkPrefix = "/home/hiring",
  compact = false,
  interactive = true,
}) {
  const description =
    post.hiring_description || post.text || post.content || "";
  const excerpt = htmlToExcerpt(description, compact ? 90 : 150);
  const cover = post.cover_image || null;
  const company = post.hiring_company || "";
  const location = post.hiring_location || "";
  const deadline = post.hiring_deadline || "";
  const accepting = isHiringAcceptingApplications(post);
  const canLink = interactive && !!linkPrefix;
  const Wrapper = canLink ? Link : "div";
  const wrapperProps = canLink
    ? {
        to: `${linkPrefix}/${post.id}`,
        style: { textDecoration: "none", color: "inherit", display: "block" },
      }
    : { style: { color: "inherit", display: "block" } };

  return (
    <div style={{ marginTop: compact ? 0 : 4 }}>
      <Wrapper {...wrapperProps}>
        {cover && !compact && (
          <FitCoverImage src={cover} maxHeight={280} radius={10} marginBottom={12} />
        )}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
          <div
            style={{
              display: "inline-block",
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 0.4,
              textTransform: "uppercase",
              color: "#0f766e",
              background: "#ccfbf1",
              padding: "3px 8px",
              borderRadius: 4,
            }}
          >
            Hiring
          </div>
          {!accepting && (
            <div
              style={{
                display: "inline-block",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 0.4,
                textTransform: "uppercase",
                color: "#991b1b",
                background: "#fee2e2",
                padding: "3px 8px",
                borderRadius: 4,
              }}
            >
              Closed
            </div>
          )}
        </div>
        <h3
          style={{
            fontSize: compact ? 15 : 20,
            fontWeight: 700,
            color: "#102a43",
            margin: "0 0 6px",
            lineHeight: 1.3,
          }}
        >
          {post.title}
        </h3>
        {(company || location) && (
          <p
            style={{
              margin: "0 0 6px",
              fontSize: compact ? 12 : 13,
              color: "#475569",
            }}
          >
            {[company, location].filter(Boolean).join(" · ")}
          </p>
        )}
        {!compact && (
          <p
            style={{
              margin: "0 0 8px",
              fontSize: 12,
              color: accepting ? "#64748b" : "#b91c1c",
            }}
          >
            {!accepting
              ? "Applications closed"
              : deadline
                ? `Apply by ${deadline}`
                : "Open until closed by employer"}
          </p>
        )}
        {excerpt && (
          <p
            style={{
              margin: "0 0 8px",
              fontSize: compact ? 12 : 14,
              color: "#475569",
              lineHeight: 1.45,
            }}
          >
            {excerpt}
          </p>
        )}
        {!compact && canLink && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#0f766e",
            }}
          >
            View details →
          </span>
        )}
      </Wrapper>
    </div>
  );
}
